/* -------------------------------------------------------------------------- */
/*                        Progress styles                        */
/* -------------------------------------------------------------------------- */

@import './bq-progress.variables';

@layer component {
  @keyframes move-indeterminate {
    0% {
      inset-inline-start: 0;
    }

    100% {
      inset-inline-start: calc(100% - var(--bq-progress-bar--indeterminateWidth));
    }
  }

  .animate-indeterminate {
    animation: move-indeterminate 1s linear 0s infinite alternate-reverse;
  }
}

.progress-bar {
  @apply relative appearance-none bs-[--bq-progress-bar--height] is-full;
}

.progress-bar::-webkit-progress-bar {
  @apply bg-[--bq-progress-bar--trackColor];
}

.progress-bar::-webkit-progress-value {
  @apply bg-[--bq-progress-bar--indicatorColor];
}

.progress-bar::-moz-progress-bar {
  @apply animate-indeterminate bg-[--bq-progress-bar--indicatorColor];
}

.progress-bar:indeterminate::-moz-progress-bar {
  @apply bg-[--bq-progress-bar--trackColor];
}

.progress-bar.progress-bar__border-shape::-webkit-progress-value,
.progress-bar.progress-bar__border-shape::-webkit-progress-bar {
  @apply rounded-full;
}

.progress-bar__indeterminate {
  @apply animate-indeterminate;
}

.progress-bar.progress-bar__border-shape::-moz-progress-bar {
  @apply animate-indeterminate rounded-full;
}
